import React, { useCallback } from 'react';
import fecha from 'fecha';
import TrainWeeklySchedule from '../../components/TrainWeeklySchedule';
import RouteInfoContext from '../RouteInfoContext';
import { useContext } from 'react';
import PropTypes from 'prop-types';
import { getPageSectionName } from '../../../utils/getPageSectionName';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';

function format24To12h(time: string) {
  const timeParsed = fecha.parse(time, 'HH:mm');
  return timeParsed ? fecha.format(timeParsed, 'h:mm A') : '';
}

export function TrainListItem({ train, onClick, pageName }) {
  const isMobile = () => window && window.innerWidth < 767;
  const trainsData = useContext(RouteInfoContext);
  const [departTime, departTimeMeridian] = format24To12h(train.departureTime).split(' ');
  const [arrivalTime, arrivalTimeMeridian] = format24To12h(train.arrivalTime).split(' ');
  const onTrainExtraSectionClickCallback = useCallback(() => {
    onClick({
      fromCityEn: train.fromCityNameEng,
      toCityEn: train.toCityNameEng,
      isMobile: isMobile(),
      fromCity: train.fromCityName,
      fromStn: train.fromStnCode,
      toCity: train.toCityName,
      toStn: train.toStnCode,
      trainNumber: train.trainNumber
    });
  }, []);
  const pageSectionName = getPageSectionName(pageName);
  return (
    <div className="positionRelative">
      <li
        className="trainList loaderOnClick"
        tabIndex={0}
        onClick={() => {
          trackClickEventProp61(pageName, `rail_seo_${pageSectionName}_trainroutecard_clicked`);
          onTrainExtraSectionClickCallback();
        }}
      >
        <div
          // style={{ marginRight: "10%" }}
          className="trainInfo"
        >
          <p className="trainNameNum">
            <a onClick={(e) => e.preventDefault()} href={train.trainPageUrl} className="trainName">
              {train.trainName}
            </a>
            <span className="trainNumber">#{train.trainNumber}</span>
          </p>
          <p className="departsDays">
            <span className="prependRight5">Departs on:</span>
            <TrainWeeklySchedule trainSchedule={train} />
          </p>
        </div>

        <div className="timeStation">
          <div className="startDepartTime">
            <span className="timeText">
              {departTime}
              <span className="timeDayText"> {departTimeMeridian} </span>
            </span>
            <span className="stationCode">{train.fromStnCode}</span>
            <a onClick={(e) => e.preventDefault()} href={train.sourceStationUrl} className="stationName">
              {train.fromStnName}
            </a>
          </div>
          <div className="travelTimeStop">
            <span className="travelHrs">
              {train.durationParts.map(({ value, unit }) => (
                <span className={'durationPart'} key={`${value}_${unit}`}>
                  <span className={'value'}>{value}</span>
                  <span className={'unit'}>{unit}</span>
                </span>
              ))}
            </span>
            <span className="timeStopBdr" />
            <span className="travelHrs">
              {/* {train.durationParts.map(({ value, unit }) => ( */}
              <span className={'durationPart'}>
                <span className={'value'}>{train.distance}</span>
              </span>
              {/* ))} */}
            </span>
          </div>

          <div className="startDepartTime">
            <span className=" timeText">
              {arrivalTime}
              <span className="timeDayText"> {arrivalTimeMeridian}</span>
            </span>
            <span className="stationCode ">{train.toStnCode}</span>
            <a onClick={(e) => e.preventDefault()} href={train.destinationStationUrl} className="stationName">
              {train.toStnName}
            </a>
          </div>
        </div>

        <div
          style={{ width: '127px', textAlign: 'center' }}
          className="bluePrimarybtn selectDateBtn pushRight"
          onClick={onTrainExtraSectionClickCallback}
        >
          <span>
            {trainsData && trainsData.miscellaneous ? trainsData.miscellaneous['SELECT DATE'] : 'Select Date'}
          </span>
        </div>
      </li>
    </div>
  );
}

TrainListItem.propTypes = {
  train: PropTypes.object,
  onClick: PropTypes.func,
  pageName: PropTypes.string
};

TrainListItem.defaultProps = {
  train: null,
  onClick: undefined,
  pageName: ''
};
